import { render, staticRenderFns } from "./Punishment.vue?vue&type=template&id=930334d8&scoped=true"
import script from "./Punishment.vue?vue&type=script&lang=js"
export * from "./Punishment.vue?vue&type=script&lang=js"
import style0 from "./Punishment.vue?vue&type=style&index=0&id=930334d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930334d8",
  null
  
)

export default component.exports